// 假数据
// type: 1目录 2菜单 3按钮
// isHidden: 是否隐藏
import servicesUser from '@/fake-data/module-menu-services/services-user.ts'
import servicesTeam from '@/fake-data/module-menu-services/services-team.ts'
import servicesWork from '@/fake-data/module-menu-services/services-work.ts'
import servicesDoSth from '@/fake-data/module-menu-services/services-do-sth.ts'
import servicesExpert from '@/fake-data/module-menu-services/services-expert.ts'
import servicesProject from '@/fake-data/module-menu-services/services-project.ts'

// 品牌
import brandsUser from '@/fake-data/module-menu-brands/brands-user.ts'
import brandsTeam from '@/fake-data/module-menu-brands/brands-team.ts'
// import brandsExpert from '@/fake-data/module-menu-brands/brands-expert.ts'
import brandsWork from '@/fake-data/module-menu-brands/brands-work.ts'
import brandsDoSth from '@/fake-data/module-menu-brands/brands-do-sth.ts'
import brandsPlan from '@/fake-data/module-menu-brands/brands-plan'

// 通用
// import commUser from '@/fake-data/module-menu-comm/comm-user.ts'
// import commTeam from '@/fake-data/module-menu-comm/comm-team.ts'

const fakeRouterServices: any = [...servicesWork, ...servicesDoSth, ...servicesProject, ...servicesExpert, ...servicesTeam, ...servicesUser]
const fakeRouterBrands: any = [...brandsWork, ...brandsDoSth, ...brandsPlan, ...brandsTeam, ...brandsUser]
const fakeRouterOthers: any = [
  // {
  //   id: '9999',
  //   parentId: '0',
  //   name: '测试目录',
  //   path: '/test',
  //   type: 1,
  //   component: '',
  //   isHidden: false,
  //   icon: 'kl-home',
  //   children: [...test]
  // }
]

export { fakeRouterOthers, fakeRouterServices, fakeRouterBrands }
